import baseService from './baseService';

export const getStrengthenQuestions = (uuid) => baseService.get(`/member/candidate_strength_questions/${uuid}`);
